export default __webpack_public_path__ + "static/media/shower.80bbed8b.svg";